import { CopyIcon } from "lucide-react";

import { Button } from "@/components/ui/button";

import { useSuccessToast } from "@/hooks/useSuccessToast";

export const CopyButton = ({ toCopy }: { toCopy: string }) => {
  const successToast = useSuccessToast();

  return (
    <Button
      className="h-auto w-auto p-0 hover:bg-transparent"
      onClick={() => {
        void navigator.clipboard.writeText(toCopy);
        successToast({ description: "Copied to clipboard!" });
      }}
      size="icon"
      variant="ghost"
    >
      <CopyIcon className="h-4 w-4 text-slate-500" />
    </Button>
  );
};
